import { useCallback, useRef, useState } from 'react';

export type ToastState = {
  title: string;
  listLabel?: string;
  href?: string;
  key: string;
};

export function useToast() {
  const [toast, setToast] = useState<ToastState | null>(null);
  const keyRef = useRef(0);

  const showToast = useCallback(
    (title: string, listLabel?: string, href?: string) => {
      keyRef.current += 1;
      // Prefixed so the key lives in its own namespace and can never collide
      // with sibling keys (e.g. SaveToListModal's integer openToken).
      setToast({ title, listLabel, href, key: `toast-${keyRef.current}` });
    },
    []
  );

  const dismissToast = useCallback(() => setToast(null), []);

  return { toast, showToast, dismissToast };
}
